import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Pagination from "react-js-pagination";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Url } from "../../config/config";

export default function ViewApplicant() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { id } = useParams(); // <-- Get job ID from URL

  const applicantsListHandler = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/applied-Jobs?jobId=${id}&page=${page}&search=${query}`,
        method: "GET",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();

      if (res.data.status === 200) {
        setRecord(res.data.data.jobList);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  useEffect(() => {
    applicantsListHandler(activePage);
    // eslint-disable-next-line
  }, []);

  //*********Handel Search************** */
  const handelSearch = (e) => {
    //setSearch(e.target.value);
    applicantsListHandler(activePage, e.target.value);
    // console.log(e.target.value);
  };

  //***********Handel pagination*********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    applicantsListHandler(pageNo);
  };
  var count = (activePage - 1) * 10 + 1;

  return (
    <React.Fragment>
      <title>Applicants</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
            </div>
            <h4 className="Title">All Applicants</h4>
            {loader}
            <div className="TableList">
              <table>
                <thead>
                  {/* "_id": "685b921a643556521934bc49",
                "firstName": "demo",
                "lastName": "pathrol",
                "phone": "8745673455",
                "email": "demo@gmail.com",
                "address1": "address1",
                "address2": "address2",
                "city": "noida",
                "state": "Uttar Pradesh",
                "pincode": "201301",
                "resume": "https://voltstorage.s3.ap-south-1.amazonaws.com/volt/1750831641654.pdf",
                "status": "pending",
                "appliedAt": "2025-06-25T06:07:22.295Z" */}
                  <tr>
                    <th>S.No</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Address1</th>
                    <th>Address2</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Pincode</th>
                    <th>Cover Letter</th>
                    <th>Resume</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.phone}</td>
                        <td>{item.email}</td>
                        <td>{item.address1}</td>
                        <td>{item.address2}</td>
                        <td>{item.city}</td>
                        <td>{item.state}</td>
                        <td>{item.pincode}</td>
                        <td>
                          {item.coverLetter ? (
                            <a
                              href={item.coverLetter}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              className="download_btn"
                            >
                              Download
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {item.resume ? (
                            <a
                              href={item.resume}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              className="download_btn"
                            >
                              Download
                            </a>
                          ) : (
                            "No Resume"
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
